import styled from '@emotion/styled';
import { FileInput } from '@mantine/core';

export const Container = styled.div({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  maxWidth: 700,
  gap: '2rem',
});

export const ContentWrapper = styled.div({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  gap: '1rem',
});

export const InputWrapper = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  gap: '1rem',
});

export const StyledFileInput = styled(FileInput)(({ theme }) => ({
  width: '100%',
}));

export const RecentFilesWrapper = styled.div(({ theme }) => ({
  marginTop: '1rem',
  padding: '1rem',
  border: `1px solid ${theme.colors.gray[3]}`,
  borderRadius: theme.radius.sm,
  backgroundColor: 'white',
}));

export const RecentFileItem = styled.div(({ theme }) => ({
  padding: '0.5rem',
  cursor: 'pointer',
  borderRadius: theme.radius.sm,
  transition: 'background-color 0.2s',
  backgroundColor: 'white',
  borderBottom: `1px solid ${theme.colors.gray[3]}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:hover': {
    backgroundColor: theme.colors.blue[1],
  },
}));
